import {ProjectsTreeSortType} from "../../../../../core/model2/space/@types"
import {SortDirection} from "../../../../../core/data-structures/sort"
import {SpaceProto} from "../../../../../core/model2/space/space-proto"
import ProjectSession from "../../../../../core/model2/project/project-session"

// const debug = "menu_getSortedChildProjects"
const debug = false

// Order one sibling list the way the menu renders it. The sort map is a single flat array of ids
// per space - ids are unique so one array ranks every level at once - with sortPosition as the
// fallback for anything not in it.
export function menu_sortProjects(projects: ProjectSession[], space: SpaceProto): ProjectSession[] {
    let sortBy : ProjectsTreeSortType = space.projectsSorting

    switch (sortBy) {
        case ProjectsTreeSortType.ALPHABETICAL  :
            debug && console.log(debug, 'sort A-Z')

            return _.orderBy(projects, (project)=>{
                return project.name.toLowerCase()   // yes to lower
            }, SortDirection.ASC)

        case ProjectsTreeSortType.MANUAL_OLD:
        default:
            debug && console.log(debug, 'sort manual')

            return _.orderBy(projects, [
                project => {
                    const index = _.indexOf(gd.user.menu.projectsAll.sortedMap[space.sortMapId], project.id)
                    if (index === -1) {
                        return projects.length
                    }
                    return index
                },
                project => project.sortPosition,
                project => project.name
            ], ['asc', 'asc', 'asc'])
    }
}

export default function menu_getSortedChildProjects(project: ProjectSession): ProjectSession[] {
    const workspace = project.workspace || gd.spaces.projects

    return menu_sortProjects(project.treeChildren, workspace)
}
